/**
 * Route mapping utility for feature card navigation
 * Maps feature card IDs to their corresponding routes
 */

export const FEATURE_CARD_ROUTES: Record<string, string> = {
  // CRM routes
  customers: "/customers",
  sms: "/campaigns/broadcast",
  reports: "/reports/customers/overview",
  products: "/products",
  transactions: "/transactions",
  sales: "/reports/sales/overview",
  automated: "/automated-campaigns",
  // Analytics routes
  "customer-overview": "/reports/customers/overview",
  "behavior-engagement": "/reports/customers/behavior",
  "purchase-patterns": "/reports/customers/purchase-pattern",
  "sales-overview": "/reports/sales/overview",
  "trends-patterns": "/reports/sales/trends",
  "product-insights": "/reports/sales/products"
};

/**
 * Get the route for a feature card by its ID
 * @param featureId - The feature card ID
 * @returns The route path, or "/" if not found
 */
export const getFeatureCardRoute = (featureId: string): string => {
  return FEATURE_CARD_ROUTES[featureId] || "/";
};
